export const getters = {

    getCustomerVoicePostSelectedPage: state => {
        return state.customervoice_post_page;
    },
    getCustomerVoicePostContentType: state => {
        return state.customervoice_post_content_type;
    },

}